import { Observable } from 'rxjs';
import { BaseController } from '~client/controller/base-controller';
import { TrackAdRequest } from '~client/model/track-ad-request';
import { TrackAdResponse } from '~client/model/track-ad-response';
import { TrackClientAdRequest } from '~client/model/track-client-ad-request';

/* User APIs pertaining to Auctions */
export class AdvertisementTrackingController extends BaseController {
  /* Returns the chances for the given offer group */
  public trackAd$(params: TrackAdRequest): Observable<TrackAdResponse> {
    return this.get$('/redirect', params);
  }

  /*  Stores the data map as JSON and returns a hash code */
  public trackClientAd$(params: TrackClientAdRequest): Observable<TrackAdResponse> {
    return this.get$('/advertisementData/public/client', params);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/controller/advertisement-tracking-controller.ts